import api from "../../utils/Api";

const BackendAdminApiBaseUrl = process.env.REACT_APP_API_URL;
const BackendApiBaseUrl = process.env.REACT_APP_ADMIN_URL;


const authApi = {
    async checkUser(payload) {
        const response = await api.post(BackendAdminApiBaseUrl + "/auth/checkUser", payload);
        return response;
    },
     async getUserRole(payload) {
        const userRole = await api.get(BackendApiBaseUrl + "/auth", payload);
        return userRole;
    },
};

export default authApi;